import React, { useState } from "react";
import Handler from "../../../Helpers/Components/Handler"
import { useDispatch, useSelector } from "react-redux";
import { PhoneInput } from "react-international-phone";
import { setBooking, setPhone, setStep } from "../../../Reducer/bookingSlice";
import { toast } from "react-toastify";
import NextPrev from "../../../Helpers/Components/NextPrev"

const Customer = (props) => {
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const dispatch = useDispatch()
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const handlePhoneChange = (phone, code, i) => {
        dispatch(setPhone({ phone: phone || "", code: code || "+91" }))
    }
    const handlePaste = (e) => {
        e.preventDefault();
        let pasteData = e.clipboardData.getData('Text');
        pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
        dispatch(setPhone({ phone: pasteData, code: e[0] || "+91" }))
    };
    const handleChange = (e) => {
        dispatch(setBooking({ [e.target.name]: e.target.value }))
    }
    const handleNext = async () => {
        if ((!booking?.firstName)) {
            toast.error("First Name is required");
        }
        // else if ((!validName.test(booking?.firstName))) {
        //     toast.error("Invalid First Name");
        // } 
        else if (!booking?.lastName) {
            toast.error("Last name is required")
        }
        //  else if ((!validName.test(booking?.lastName))) {
        //     toast.error("Invalid Last Name");
        // } 
        else if (!booking?.phone?.phone) {
            toast.error("Phone number is required");
        } else if ((booking?.phone?.code === "+91" || booking?.phone?.code === "91") && !validPhoneNumber.test(booking?.phone?.phone)) {
            toast.error("Phone number is Invalid");
        } else {
            // setLoading(true)
            // const data = {
            //     firstName: booking?.firstName,
            //     lastName: booking?.lastName,
            //     phone: booking?.phone?.phone,
            //     customerId: booking?.customerId,
            //     carId: booking?.carId,
            //     deliveryDetails: booking?.deliveryDetails,
            //     pickupDetails: booking?.pickupDetails,
            //     totalDays: (Number(booking?.totalDays || 0) + Number(booking?.point || 0)) || 0
            // }
            // const response = await Handler({ url: `/booking/details/first/update/${props?.bookingId}`, method: 'patch', data })
            // if (response?.success) {
            dispatch(setStep(1))
            // } else {
            //     toast.error(response?.message)
            // }
            // setLoading(false)
        }
    }
    const setSteps = () => {
        dispatch(setStep(1))
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="firstName" className="form-label"> First Name </label>
                        <input onChange={handleChange} name="firstName" id="firstName" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.firstName || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="lastName" className="form-label"> Last Name </label>
                        <input onChange={handleChange} name="lastName" id="lastName" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.lastName || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="phone" className="form-label"> Mobile </label>
                        <PhoneInput
                            defaultCountry="in"
                            disabled={loading}
                            onPaste={handlePaste}
                            value={booking?.phone?.phone ? booking?.phone?.code + booking?.phone?.phone : ""}
                            onChange={(phone1, metadata) => {
                                const code = `+${metadata.country.dialCode}`;
                                const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                handlePhoneChange(phone, code, 1)
                            }}
                        />
                    </div>
                </div>
            </div>
            <NextPrev step={0} setStep={setSteps} last={2} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Customer;